import { useSelector } from 'react-redux';

import { authStoreUserTournamentId } from 'modules/auth/store/selectors';
import { ListChampionshipsArgs, useListChampionshipsQuery } from 'modules/tournaments/store/tournaments/championships-api';
import { useOffsetPagination } from 'shared/hooks/use-offset-pagination';

const filtersConfig = {
  namePart: { key: 'namePart', defaultValue: '' as string },
};

export function useChampionshipsList() {
  const tournamentId = useSelector(authStoreUserTournamentId);

  return useOffsetPagination<any, ListChampionshipsArgs, typeof filtersConfig>({
    useQueryHook: useListChampionshipsQuery,
    baseArgs: { tournamentId: Number(tournamentId) },
    mapFiltersToArgs: (f) => ({
      namePart: f.namePart || undefined,
    }),
    filtersConfig,
    perPageStorageKey: 'championshipsPerPage',
    defaultPerPage: 10,
    queryOptions: () => ({ skip: !tournamentId }),
  });
}
